module.exports = __webpack_public_path__ + "static/media/gameLibrarian.e59f059e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameLibrarian.png
// module id = 2531
// module chunks = 0